import { useEffect, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const TESTIMONIALS = [
  {
    quote:
      "FastSearch ne hamari legal recovery team ko ek hi platform par la diya. Vehicle search, case assignment, aur field updates ab real time milte hain.",
    name: "Lokesh Sharma",
    role: "Repo Admin",
    org: "Legal Repossession Agency",
    image: "/img/testimonials/dashboard.jpg",
    imageAlt: "FastSearch instant records search and case management on mobile",
  },
  {
    quote:
      "Bank / NBFC records upload ke baad agency ko authorized cases jaldi mil jaate hain. Status, confirmations, aur seizures track karna simple ho gaya hai.",
    name: "Priya Mehta",
    role: "Operations Lead",
    org: "NBFC Recovery Desk",
    image: "/img/testimonials/search.jpg",
    imageAlt: "FastSearch vehicle search results across India",
  },
  {
    quote:
      "Field par vehicle dhoondhna, case update karna, aur inventory upload karna app se fast hai. Team ko har case ki clear visibility milti hai.",
    name: "Ravi Kumar",
    role: "Team Leader",
    org: "Ground Recovery Team",
    image: "/img/testimonials/cases.jpg",
    imageAlt: "FastSearch app for managing cases and seizures",
  },
  {
    quote:
      "Vehicle number se customer, chassis, engine, aur case status turant mil jaata hai. Loaded details update karna bhi asaan hai.",
    name: "Sandeep Jain",
    role: "Office Staff",
    org: "Legal Recovery Operations",
    image: "/img/testimonials/details.jpg",
    imageAlt: "FastSearch vehicle and customer details on mobile",
  },
];

const AUTO_MS = 4000;

export default function TestimonialsCarousel() {
  const [index, setIndex] = useState(0);
  const total = TESTIMONIALS.length;

  useEffect(() => {
    const timer = window.setInterval(() => {
      setIndex((current) => (current + 1) % total);
    }, AUTO_MS);
    return () => window.clearInterval(timer);
  }, [total]);

  const go = (next) => {
    setIndex((next + total) % total);
  };

  return (
    <section className="login-testimonials" aria-labelledby="login-testimonials-heading">
      <h2 id="login-testimonials-heading" className="login-testimonials__title">
        What recovery teams say
      </h2>
      <p className="login-testimonials__lead">
        Agencies, field teams, and recovery desks using FastSearch App/Web.
      </p>

      <div
        className="login-testimonials__frame"
        aria-roledescription="carousel"
        aria-label="Customer testimonials"
      >
        <button
          type="button"
          className="login-testimonials__nav"
          aria-label="Previous testimonial"
          onClick={() => go(index - 1)}
        >
          <FiChevronLeft aria-hidden />
        </button>

        <div className="login-testimonials__viewport">
          <div
            className="login-testimonials__track"
            style={{ transform: `translateX(-${index * 100}%)` }}
          >
            {TESTIMONIALS.map((item) => (
              <figure key={item.name} className="login-testimonials__card">
                <img
                  className="login-testimonials__image"
                  src={item.image}
                  alt={item.imageAlt}
                />
              </figure>
            ))}
          </div>
        </div>

        <button
          type="button"
          className="login-testimonials__nav"
          aria-label="Next testimonial"
          onClick={() => go(index + 1)}
        >
          <FiChevronRight aria-hidden />
        </button>
      </div>

      <div className="login-testimonials__dots" role="tablist" aria-label="Choose testimonial">
        {TESTIMONIALS.map((item, i) => (
          <button
            key={item.name}
            type="button"
            role="tab"
            aria-selected={i === index}
            aria-label={`Show testimonial from ${item.name}`}
            className={`login-testimonials__dot${i === index ? " is-active" : ""}`}
            onClick={() => setIndex(i)}
          />
        ))}
      </div>
    </section>
  );
}
